import script from "./bill_view.vue?vue&type=script&setup=true&lang=js"
export * from "./bill_view.vue?vue&type=script&setup=true&lang=js"

import "./bill_view.vue?vue&type=style&index=0&id=6fb10ec0&lang=css"

const __exports__ = script;

export default __exports__